var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('GmapInfoWindow',{attrs:{"position":_vm.position,"opened":_vm.opened}},[_c('div',[_c('b',[_vm._v(_vm._s(_vm.content))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }